var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
var StyledButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      background-color: transparent;\n      border: 0;\n      color: " + (theme === null || theme === void 0 ? void 0 : theme.color.background.foreground) + ";\n      font-family: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.family) + ";\n      font-size: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.size.mediumTEMP) + ";\n      margin: 0;\n      padding: 0 0 " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xs) + ";\n      text-decoration: none;\n      white-space: nowrap;\n    ";
});
var Item = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      list-style: none;\n      margin: -2px 0 0 " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.large) + ";\n      padding: 0;\n\n      :first-child {\n        margin-left: 0;\n      }\n\n      &.active {\n        button {\n          font-weight: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.weight.bold) + ";\n          border-bottom: 4px solid " + (theme === null || theme === void 0 ? void 0 : theme.color.secondary.background) + ";\n        }\n      }\n    ";
});
export function SATabBarItem(_a) {
    var active = _a.active, label = _a.label, onClick = _a.onClick;
    var _b = useState('auto'), width = _b[0], setWidth = _b[1];
    var ref = useRef(null);
    useEffect(function () {
        // TODO: Clean this up. It works, but feels messy.
        setWidth("" + (ref.current ? ref.current.offsetWidth : 0));
    }, [ref.current]);
    var cssClass = active ? 'active' : '';
    if (onClick) {
        return (React.createElement(Item, { className: cssClass },
            React.createElement(StyledButton, { ref: ref, type: "button", onClick: function () { return onClick(width); } }, label)));
    }
    return (React.createElement(Item, { className: cssClass },
        React.createElement(StyledButton, { type: "button" }, label)));
}
SATabBarItem.defaultProps = {
    active: false,
    label: 'Item',
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=item.component.js.map